import { styled } from '@mui/material';
import { BaseCardLabel } from 'console/shared/styles/mixins/base-card';
export const DeviceName = styled(BaseCardLabel)({});
